import PropertySet from '@tcc/shared/src/helpers/property';

const _experiments = new PropertySet();

export default _experiments;
